// Copyright (c) Move Closer 2022.

import { PrivacyConfig } from '@core'

/**
 * @author Łukasz Sitnicki <lukasz.sitnicki@movecloser.pl>
 */
export const privacy: PrivacyConfig = {
  enabled: false,
  options: ['analytics', 'usercom'],
  required: ['analytics', 'usercom']
}
